export default "__VITE_ASSET__CWaJYrvt__"